/**
 * Normalizes a phone number to 10-digit format.
 * Strips all non-digit characters and extracts the last 10 digits.
 * Mirrors backend logic in LoginIdentifierType::normalizePhone().
 *
 * @example
 *   normalizePhone('+1 (555) 123-4567') // '5551234567'
 *   normalizePhone('555-123-4567')       // '5551234567'
 *   normalizePhone('5551234567')         // '5551234567'
 *   normalizePhone(null)                 // ''
 */
export function normalizePhone(value: string | null | undefined): string {
  if (!value) return '';

  const digitsOnly = value.replace(/\D/g, '');

  if (digitsOnly.length < 10) {
    return digitsOnly;
  }

  return digitsOnly.slice(-10);
}

/**
 * Formats a phone number string to (XXX)-XXX-XXXX display format.
 * Normalizes the input first, then applies formatting.
 *
 * @example
 *   formatPhone('5551234567')         // '(555)-123-4567'
 *   formatPhone('(555) 123-4567')     // '(555)-123-4567'
 *   formatPhone(null)                 // ''
 */
export function formatPhone(value: string | null | undefined): string {
  const digits = normalizePhone(value);

  if (digits.length !== 10) return value?.trim() || '';

  return `(${digits.substring(0, 3)})-${digits.substring(3, 6)}-${digits.substring(6, 10)}`;
}
